
import Vue, {PropType} from "vue";
import {
  AscendingComparatorDecorator,
  AttributeComparator,
  DefaultProductComparator,
  DescendingComparatorDecorator,
  NameAscComparator,
  PriceLowAscComparator,
  ProductComparator
} from "../../model/ProductBusinessLogic";
import {ProductMetaModel} from "../../model/product/ProductMetaModel";
import {ProductValues} from "../../model/product/ProductValues";
import {AttributeVisibility} from "../../model/shared/AttributeVisibility";
import {Dictionary} from "lodash";

export default Vue.extend({
  name: 'sort-product-select',
  props: {
    metaModels: {
      type: Object as PropType<Dictionary<ProductMetaModel>>,
      required: true,
    },
    unsortedProducts: {
      type: Array<ProductValues>,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      baseComparators: [
        new AscendingComparatorDecorator(new NameAscComparator()),
        new DescendingComparatorDecorator(new NameAscComparator()),
        new AscendingComparatorDecorator(new PriceLowAscComparator()),
        new DescendingComparatorDecorator(new PriceLowAscComparator())
      ],
      selected: 0, // index of the first element in baseComparators
    };
  },
  computed: {
    comparators(): Array<ProductComparator> {
      const comparators = [...this.baseComparators];
      const seen = new Set<number>();

      // Iteration over the products
      for (const metaModel of Object.values(this.metaModels)) {
        const visibleAttributes = metaModel.getAttributesByVisibility(AttributeVisibility.SORT);

        // Iterate over the specific attributes that should be integrated in the sort
        for (let i = 0; i < visibleAttributes.length; ++i) {
          const attribute = visibleAttributes[i];

          if (!seen.has(attribute.id)) {
            seen.add(attribute.id);
            const attributeComparator = new AttributeComparator(attribute.id, attribute.name);
            comparators.push(new AscendingComparatorDecorator(attributeComparator));
            comparators.push(new DescendingComparatorDecorator(attributeComparator));
          }
        }
      }
      return comparators;
    },
    options(): Array<any> {
      return this.comparators.map((it, index) => ({
        text: it.getLabel(this.$i18n),
        value: index,
      }));
    },
  },
  methods: {
    handleChange(value: string): void {
      let strategy = value === "null" ? new DefaultProductComparator() : this.comparators[parseInt(value)];
      this.$emit("sortChanged", strategy);
    },
  }
})
